import Cache from '@/helper/Cache.js'
import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import _ from 'lodash'

export default {
  KEY_COOKIE_LOCALE: 'BzbsLocale',
  defaultLocale: 'th',
  localVersion: {},
  config: function () {
    return Vue.bzbsConfig
  },
  setDefaultLocale: function () {
    var locale = Cache.get(this.KEY_COOKIE_LOCALE)
    if (Vue.bzbsConfig.businessRule.webFor.PH) {
      if (locale == 'ph_en') {
        this.defaultLocale = 'ph_en'
        Cache.set(this.KEY_COOKIE_LOCALE, this.defaultLocale)
      } else {
        this.defaultLocale = 'ph'
        Cache.set(this.KEY_COOKIE_LOCALE, this.defaultLocale)
      }
    } else {
      if (locale != 'ph' && locale != null) {
        Cache.set(this.KEY_COOKIE_LOCALE, locale)
      } else {
        this.defaultLocale = 'th'
        Cache.set(this.KEY_COOKIE_LOCALE, this.defaultLocale)
      }
    }
  },
  setLocale(route, url = null) {
    if (url) {
      if (url.search.includes('locale=')) {
        var locale = url.search.split('locale=')[1].split('&')[0]
        if (locale != undefined && locale != null) {
          Cache.set(this.KEY_COOKIE_LOCALE, locale)
        }
      }
    }
    this.setDefaultLocale()
    return new Promise(resolve => {
      var locale = Cache.get(this.KEY_COOKIE_LOCALE)
      if (locale == null) {
        if (route.query.locale != undefined) {
          Cache.set(this.KEY_COOKIE_LOCALE, route.query.locale)
          return resolve(true)
        } else {
          Cache.set(this.KEY_COOKIE_LOCALE, this.defaultLocale)
          return resolve(false)
        }
      } else {
        if (route.query.locale != undefined) {
          if (route.query.locale != locale) {
            Cache.set(this.KEY_COOKIE_LOCALE, route.query.locale)
          }
        }
        return resolve(true)
      }
    })
  },
  getLocale() {
    this.setDefaultLocale()
    var locale = Cache.get(this.KEY_COOKIE_LOCALE)
    if (locale == null) {
      locale = this.defaultLocale
    }
    return locale
  },
  async callBlobVersion() {
    console.log('callBlobVersion')
    var urlVersion =
      this.config().bzbBlobUrl + '/crmplus-consumer/language/version.json'

    const response = await BzbsApi.connectBzbsGetBlob(urlVersion)
    this.localVersion = response.data
  },
  getLbl() {
    var version = this.localVersion
    _.forEach(version, (item, keycode) => {
      var urlLocale =
        this.config().bzbBlobUrl +
        '/crmplus-consumer/language/' +
        keycode +
        '/' +
        item.current_version +
        '.json'
      BzbsApi.connectBzbsGetBlob(urlLocale).then(response => {
        localStorage.setItem(
          'setJsonLocal_' + keycode,
          JSON.stringify(response.data),
        )
        return response
      })
    })
  },
}
